import makeStyles from "@material-ui/styles/makeStyles";

const styles = makeStyles(theme => ({
	animationWrapper: {
		color: theme.palette.common.white,
		height: "70vh",
		position: "relative",
		width: "100%"
	},
	animationWrapperIntro: {
		height: `calc((var(--vh, 1vh) * 100) - 96px)`
	},
	animation: {
		height: "100%",
		padding: theme.spacing(0, 3, 5),
		position: "relative",
		[theme.breakpoints.up("md")]: {
			padding: theme.spacing(0, 7, 7)
		},
		"& .mco-animation-01": {
			overflow: "visible"
		},
		"& .mco-animation-01__image": {
			borderRadius: "0 0 4px 4px",
			overflow: "hidden"
		},
		"& .mco-animation-01__texts": {
			bottom: theme.spacing(5),
			display: "flex",
			flexDirection: "column",
			gap: theme.spacing(1),
			left: theme.spacing(3),
			right: theme.spacing(3),
			[theme.breakpoints.up(1500)]: {
				bottom: theme.spacing(7),
				left: "50%",
				margin: "0 0 0 -640px",
				maxWidth: 1280
			},
			"& a": {
				background: theme.palette.primary.main,
				borderRadius: 4,
				color: theme.palette.common.white,
				display: "inline-block",
				fontSize: 18,
				fontWeight: 600,
				letterSpacing: 0.05,
				lineHeight: 1,
				padding: theme.spacing(1.75, 3),
				textTransform: "uppercase"
			}
		},
		"& .mco-animation-01__text--1": {
			fontSize: 42,
			textTransform: "uppercase"
		},
		"& .mco-animation-01__text--2": {
			fontSize: 38
		},
		"& .mco-animation-01__bullets": {
			bottom: -theme.spacing(3),
			[theme.breakpoints.up("md")]: {
				bottom: -theme.spacing(4)
			}
		},
		"& .mco-animation-01__bullet": {
			background: theme.palette.primary.main,
			borderRadius: 2,
			height: 8,
			width: 8
		}
	},
	scrollBottom: {
		[theme.breakpoints.down("sm")]: {
			display: "none"
		},
		alignItems: "center",
		color: theme.palette.primary.main,
		cursor: "pointer",
		display: "flex",
		flexDirection: "row-reverse",
		fontSize: 14,
		fontWeight: 600,
		gap: theme.spacing(1),
		lineHeight: 1,
		letterSpacing: 0.05,
		left: 16,
		position: "absolute",
		textTransform: "uppercase",
		transform: "rotate(-90deg)",
		transformOrigin: "left top",
		userSelect: "none"
	}
}));

export default styles;
